<!-- Prevent prettier to remove parentheses from v-model type cast -->
<!-- prettier-ignore -->
<template>
  <form class="flex items-start gap-20" @submit.prevent="handleFilter">
    <div class="grid grow grid-cols-4 gap-16">
      <RevInputText
        id="model"
        v-model="filterValues.model"
        :label="i18n(translations.modelLabel)"
        name="model"
      />
      <RevInputText
        id="brand"
        v-model="filterValues.brand"
        :label="i18n(translations.brandLabel)"
        name="brand"
      />
      <RevInputSelect
        id="grade"
        v-model="(filterValues.grades as Value)"
        :label="i18n(translations.gradeLabel)"
        name="grade"
        :options="gradeOptions"
      />
      <RevInputSelect
        id="online"
        v-model="(filterValues.state as Value)"
        :label="i18n(translations.publicationStateLabel)"
        name="online"
        :options="stateOptions"
      />
      <template v-if="showMore">
        <RevInputText
          id="productId"
          v-model="filterValues.productId"
          :label="i18n(translations.prodcutIdLabel)"
          name="productId"
        />
        <RevInputText
          id="sku"
          v-model="filterValues.sku"
          :label="i18n(translations.skuLabel)"
          name="sku"
        />
        <RevInputText
          id="releaseYear"
          v-model="filterValues.releaseYear"
          :label="i18n(translations.releaseYearLabel)"
          name="releaseYear"
          type="number"
        />
      </template>

      <RevButton
class="w-fit self-start"
        size="small"
        variant="secondary"
        @click="showMore = !showMore"
      >
        {{ showMoreFiltersLabel }}
      </RevButton>
    </div>
    <div class="flex items-center gap-24">
      <RevButton :loading="isFiltering" type="submit" variant="primary">
        {{ i18n(translations.applyFilters) }}
      </RevButton>
      <RevLink
        :loading="isResetting"
        variant="secondary"
        @click="handleResetFilters"
      >
        {{ i18n(translations.reset) }}
      </RevLink>
    </div>
  </form>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevInputSelect, type Value } from '@ds/components/InputSelect'
import { RevInputText } from '@ds/components/InputText'
import { RevLink } from '@ds/components/Link'

import { FILTERS_BUTTONS } from '../Filters.constants'
import translations from '../Filters.translations'
import type {
  FilterOption,
  QuotesFilterEventPayload,
  QuotesFilters,
} from '../Filters.types'

const props = withDefaults(
  defineProps<{
    initialValues: QuotesFilters
    gradeOptions: Array<FilterOption>
    stateOptions: Array<FilterOption>
    loadingButton?: string
  }>(),
  {
    loadingButton: '',
  },
)
const emit = defineEmits<{
  (e: 'filter', payload: QuotesFilterEventPayload): void
}>()

const showMore = ref(false)
const filterValues = ref({ ...props.initialValues })
const i18n = useI18n()

const isFiltering = computed(
  () => props.loadingButton === FILTERS_BUTTONS.FILTER,
)
const isResetting = computed(
  () => props.loadingButton === FILTERS_BUTTONS.RESET,
)
const showMoreFiltersLabel = computed(() =>
  showMore.value
    ? i18n(translations.showLessFilters)
    : i18n(translations.showMoreFilters),
)

function handleFilter() {
  emit('filter', {
    filters: { ...filterValues.value },
    actionButton: FILTERS_BUTTONS.FILTER,
  })
}
function handleResetFilters() {
  filterValues.value = { ...props.initialValues }
  emit('filter', {
    filters: { ...filterValues.value },
    actionButton: FILTERS_BUTTONS.RESET,
  })
}
</script>
